export const removeArrayDuplicates = array => {
	return Array.from(new Set(array));
};

export const isEqual = (val1, val2) => {
	if (val1 === val2) return true;

	if (val1 instanceof Date && val2 instanceof Date) {
		return val1.getTime() === val2.getTime();
	}

	if (Array.isArray(val1) && Array.isArray(val2)) {
		if (val1.length !== val2.length) return false;
		return val1.every((item, i) => isEqual(item, val2[i]));
	}

	if (typeof val1 === "object" && typeof val2 === "object" && val1 !== null && val2 !== null) {
		const sharedKeys = Object.keys(val1).filter(key => key in val2);
		for (const key of sharedKeys) {
			if (!isEqual(val1[key], val2[key])) return false;
		}
		return true;
	}

	return false;
};

export const hasFormChanged = (initialData, formData) => {
	const sharedKeys = Object.keys(formData).filter(key => key in initialData);
	for (const key of sharedKeys) {
		if (!isEqual(formData[key], initialData[key])) {
			return true;
		}
	}
	return false;
};

export const camelCaseToWords = s => {
	const result = s.replace(/([A-Z])/g, " $1");
	return result.charAt(0).toUpperCase() + result.slice(1);
};

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
export const CANCELED_REQUEST_MESSAGE = "canceled";
